export default function initForms() {
    const $document = $(document);

    function showValidationErrors(currentTarget, xhr) {
        currentTarget.find('[name]').removeClass('is-invalid');
        currentTarget.find('.invalid-feedback').remove();

        $.each(xhr.responseJSON.errors, (key, value) => {
            currentTarget
                .find(`[data-error-for-input-name="${key}"],[name="${key}"]`)
                .first()
                .addClass('is-invalid')
                .after(`<div id="error-${key}" class="invalid-feedback">${value[0]}</div>`);
        });
    }

    function formError(xhr, $currentTarget) {
        if (xhr.status === 422) {
            showValidationErrors($currentTarget, xhr);
        } else {
            $currentTarget.html(`<div class="alert alert-danger" role="alert">${$currentTarget.attr('data-error')}</div>`);
        }
    }

    function formSuccess(xhr, $currentTarget) {
        const template = $currentTarget.find('script[type="text/template"]');
        let html;

        if (template.length > 0 && {}.propertyIsEnumerable.call(xhr, 'responseJSON')) {
            html = template.text();
            Object.keys(xhr.responseJSON).forEach(key => {
                html = html.replace(new RegExp(`:${key}`, 'g'), xhr.responseJSON[key]);
            });
        } else {
            html = `<div class="alert alert-success" role="alert">${$currentTarget.attr('data-success')}</div>`;
        }

        $currentTarget.hide().before(html);
    }

    $document.on('submit', 'form[data-ajax]', (e) => {
        e.preventDefault();
        const $currentTarget = $(e.currentTarget);

        $.ajax({
            method: $currentTarget.attr('method'),
            url: $currentTarget.attr('action'),
            data: $currentTarget.serialize(),
            error(xhr) {
                formError(xhr, $currentTarget);
            },
            success(data, textStatus, xhr) {
                formSuccess(xhr, $currentTarget);
            },
        });
    });
}